import React from "react";
import DropDownComponent from "./formComponents/DropDownComponent";

const PerformanceFilters = ({ filters, options, onFilterChange }) => {
  return (
    <div className="perf-filters-row">
      <div className="perf-filter-item">
        <DropDownComponent
          options={options.courses}
          value={filters.courseId}
          onChange={(val) => onFilterChange("courseId", val)}
          placeholder="Course"
        />
      </div>
      <div className="perf-filter-item">
        <DropDownComponent
          options={options.batches}
          value={filters.batchId}
          onChange={(val) => onFilterChange("batchId", val)}
          placeholder="Batch"
        />
      </div>
      <div className="perf-filter-item">
        <DropDownComponent
          options={options.students}
          value={filters.studentId}
          onChange={(val) => onFilterChange("studentId", val)}
          placeholder="Student"
        />
      </div>
      <div className="perf-filter-item">
        <DropDownComponent
          options={options.subjects}
          value={filters.subjectId}
          onChange={(val) => onFilterChange("subjectId", val)}
          placeholder="Subject"
        />
      </div>
      <div className="perf-filter-item perf-filter-date">
        <label className="perf-date-label">From</label>
        <input
          type="date"
          className="perf-date-input"
          value={filters.from}
          max={filters.to}
          onChange={(e) => onFilterChange("from", e.target.value)}
        />
      </div>
      <div className="perf-filter-item perf-filter-date">
        <label className="perf-date-label">To</label>
        <input
          type="date"
          className="perf-date-input"
          value={filters.to}
          min={filters.from}
          onChange={(e) => onFilterChange("to", e.target.value)}
        />
      </div>
    </div>
  );
};

export default PerformanceFilters;
